const Field = {
  // field types
  TYPE_INPUT: 'input',
  TYPE_SELECT: 'select',
  TYPE_RADIO: 'radio',
  TYPE_CHECK: 'check',
  TYPE_BUTTON: 'button',
  TYPE_AREA: 'area',
  TYPE_LABEL: 'label',
  TYPE_TITLE: 'title',
  TYPE_FILE: 'file',
  TYPE_MULTIPLE: 'multiple',
  TYPE_HIDDEN: 'hidden',
  TYPE_PASSWORD: 'password',
  TYPE_GRID: 'grid',
  TYPE_IMAGE: 'image',
  TYPE_HREF: 'href',
  TYPE_EDITOR: 'editor',
  TYPE_TREE: 'tree',
  TYPE_CAPTCHA: 'captcha',

  // field functions
  FUNC_CLICK: 'onclick',
  FUNC_CHANGE: 'onchange',
  FUNC_MODAL_RETURN: 'onmodalreturn',

  FUNC_ROW_ADD: 'onrowadd',
  FUNC_ROW_DELETE: 'onrowdelete',
  FUNC_ROW_SORT: 'onrowsort',
  FUNC_COL_SELECT: 'oncolselect',

  // Attribute w/ props json for fields
  FIELD_PROPERTIES: 'properties',

  // Field properties
  PROPERTY_NAME: 'name',
  PROPERTY_SIZE: 'size',
  PROPERTY_READONLY: 'readonly',
  PROPERTY_DISABLED: 'disabled',
  PROPERTY_MODAL_DISABLED: 'modalDisabled',
  PROPERTY_FONT_COLOR: 'fontColor',
  PROPERTY_VALUE: 'value',
  PROPERTY_REQUIRED: 'required',
  PROPERTY_COLSPAN: 'colspan',
  PROPERTY_ROWSPAN: 'rowspan',
  PROPERTY_MODAL: 'modal',
  PROPERTY_ROWS: 'thisRows',
  PROPERTY_BOLD: 'bold',
  PROPERTY_UNDERLINED: 'underlined',
  PROPERTY_ALIGNMENT: 'alignment',
  PROPERTY_IMAGE: 'imageUrl',
  PROPERTY_COL_WIDTH: 'colWidth',
  PROPERTY_GRID_HEIGHT: 'gridHeight',
  PROPERTY_HIDE_GRID_BTN: 'hideGridButtons',
  PROPERTY_VISIBILITY_HIDDEN: 'visibilityHidden',
  PROPERTY_TRANSIENT: 'transient',
  PROPERTY_GRID_TITLE: 'gridTitle',
  PROPERTY_GRID_FORM: 'gridForm',
  PROPERTY_TOOLTIP: 'tooltip',
  PROPERTY_VALUE_COLOR: 'valueColor',
  PROPERTY_INPUT_AS_TEXT: 'inputAsText',
  PROPERTY_NO_DOWNLOAD: 'noDownload',
  PROPERTY_NO_ERASE: 'noErase',
  PROPERTY_NO_LOCK: 'noLock',
  PROPERTY_NO_HISTORY: 'noHistory',
  PROPERTY_NO_MODIFY: 'noModify',
  PROPERTY_ALLOW_EDITION: 'allowEdition',
  PROPERTY_HIDE_SIGN_ICONS: 'hideSignButtons',
  PROPERTY_URL: 'url',
  PROPERTY_GRID_HIDE_BTN_ORDER: 'hideOrderButton',
  PROPERTY_GRID_HIDE_BTN_INCLUDE: 'hideIncludeButton',
  PROPERTY_REGEXP_MESSAGE: 'regExpMessage',
  PROPERTY_PAGED_GRID: 'paged',
  PROPERTY_PAGED_GRID_SIZE: 'pagedGridSize',
  PROPERTY_GRID_ALTER_IN_LAST_PAGE: 'alterOnlyLastPage',
  PROPERTY_GRID_PRINT_HORIZONTAL: 'printHorizontal',
  PROPERTY_STORE_MODAL_QUERY_RESULT: 'storeMdlQryResult',
  PROPERTY_INCLUDE_FIRST_ROW: 'includeFirstRow',
  PROPERTY_MAX_REG_GRID: 'maxRecords',
  PROPERTY_GRID_LABEL: 'gridColTitle',
  PROPERTY_GRID_QUERY: 'gridQuery',
  PROPERTY_HIDE_DOC_PERMISSIONS: 'hideDocPermissions',
  PROPERTY_VERIFY_SIGNATURE_ONLY: 'verifySignatureOnly',
  PROPERTY_GRID_HIDE_BTN_ADD: 'hideAddButton',
  PROPERTY_GRID_HIDE_BTN_DEL: 'hideDelButton',
  PROPERTY_HIDE_DOC_UPLOAD: 'hideDocUpload',
  PROPERTY_HIDE_DOC_DOWNLOAD: 'hideDocDownload',
  PROPERTY_HIDE_DOC_ERASE: 'hideDocErase',
  PROPERTY_HIDE_DOC_LOCK: 'hideDocLock',
  PROPERTY_HIDE_DOC_HISTORY: 'hideDocHistory',
  PROPERTY_HIDE_DOC_SIGN: 'hideSignButtons',
  PROPERTY_DISPLAY_NONE: 'displayNone',
  PROPERTY_DONT_BREAK_RADIO: 'dontBreakRadio',
  PROPERTY_CHECKED: 'checked',
  PROPERTY_FILE_PREVIEW: 'filePreview',
  PROPERTY_NOT_PRINT: 'noPrint',
  // tree component
  PROPERTY_SELECT_PARENT: 'selParent',
  PROPERTY_HEIGHT: 'height',
  PROPERTY_MULTISELECT: 'multiselect',
  PROPERTY_SEL_PARENT: 'selParent',
  PROPERTY_PARENT_ICON: 'parentIcon',
  PROPERTY_LEAF_ICON: 'leafIcon',
  PROPERTY_CSS_CLASS: 'cssClass',
  PROPERTY_DOC_TYPE: 'docType',
  // file component
  PROPERTY_HIDE_DOC_METADATA: 'hideDocMetadata',
  PROPERTY_TRANSLATION_REQUIRED: 'reqTrad',
  PROPERTY_SIGNATURE_REQUIRED: 'reqSign',
  PROPERTY_SHOW_TOOLTIP_AS_HELP: 'tooltipHelp',
  PROPERTY_DOCUMENT_MONITOR_DEF: 'documentMonitorDef',
  PROPERTY_DOCUMENT_MONITOR_CUS: 'documentMonitorCus',
  PROPERTY_DOCUMENT_SHOW_FOLD_TREE_BTN: 'fileShwFoldTreeBtn',
  PROPERTY_DOCUMENT_SHOW_FOLD_TREE_STR: 'fileShwFoldTreeStr',
  PROPERTY_DOCUMENT_NO_ALLOW_DRAG_DROP: 'fileNoAllwDnD',
  PROPERTY_DOCUMENT_NO_SHOW_MODAL: 'fileDntShwDocMdlOnDrop',
  PROPERTY_DOCUMENT_SHOW_DESC: 'fileShowDesc',
  PROPERTY_DOCUMENT_DEFAULT_FOLDER: 'fileDefFolder',
  PROPERTY_DOCUMENT_ROOT_FOLDER: 'fileRootFolder',
  PROPERTY_DOCUMENT_EXP_DATE: 'fileExpDate',
  PROPERTY_DOCUMENT_DNT_SHW_DOC_MON: 'fileNotShowDocMon',
  PROPERTY_DOCUMENT_COLLAPSE_PERM: 'fileCollapsePermission',
  PROPERTY_DOCUMENT_COLLAPSE_META: 'fileCollapseMetadata',
  PROPERTY_DOCUMENT_COLLAPSE_FLD_STC: 'fileCollapseFldStrc',

  // Mensajes de error
  WRONG_ATT_TYPE_ERROR:
    'Component does not support attributes of type <TOK>. Contact system administrator',

  // Keys almacenadas en los campos
  STORE_KEY_FIELD: 'field',
  STORE_KEY_FORM: 'form',

  PROPERTY_ARIA_DESCRIPTION: 'ariaDescription',
  PROPERTY_ARIA_LABEL: 'ariaLabel',
  PROPERTY_ALT: 'alt',
  PROPERTY_AUTO_COMPLETE: 'autoComplete',
  PROPERTY_AUTO_FOCUS: 'autoFocus',
  PROPERTY_INPUT_TYPE: 'inputType',
  PROPERTY_PLACE_HOLDER: 'placeHolder',
  PROPERTY_TITLE: 'title',

  PROPERTY_GRID_HIDE_DOC_INFO_BUTTON: 'hideDocInfoButton',
} as const;

export default Field;
